import React from 'react';
import PropTypes from 'prop-types';
import localize from '@Components/localize';
import {useAuth} from '@Services/AuthService/useAuth';
import { navigateTo } from '@Services/navigation';

const ContentHead = ({translate}) => {
	const { logout, token } = useAuth();

	if (!token) return '';

	const doLogout = () => {
		logout();
		navigateTo('home');
	};

	return (
		<div className="flex--row_center-end relative--pos">
			<div onClick={doLogout} className="button-blue flex--row_center-center width--px_140">
				<span className="color--white">{translate('sign_out')}</span>
				<i className="icon-menu icon--logout margin--left_8"></i>
			</div>
		</div>
	)
};

ContentHead.propTypes = {
	translate: PropTypes.func,
};

export default localize(ContentHead);
